import {
  registerDecorator,
  type ValidationArguments,
  type ValidationOptions,
} from 'class-validator';

/**
 * Class validator that checks if two boolean fields are mutually exclusive.
 * Both fields can be false, but they cannot both be true at the same time.
 */
export function MutuallyExclusiveWith<T>(
  property: keyof T,
  validationOptions?: ValidationOptions,
) {
  return function (object: unknown, propertyName: string) {
    registerDecorator({
      name: 'mutuallyExclusiveWith',
      target: object.constructor,
      propertyName,
      constraints: [property],
      options: validationOptions,
      validator: {
        validate(value: unknown, args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints;
          const relatedValue = (args.object as Record<string, unknown>)[
            relatedPropertyName as string
          ];

          // If both are explicitly true, validation fails
          if (value === true && relatedValue === true) {
            return false;
          }

          // Otherwise valid (both false, one true/one false, undefined, etc.)
          return true;
        },

        defaultMessage(args: ValidationArguments) {
          const [relatedPropertyName] = args.constraints;
          return `${args.property} and ${String(relatedPropertyName)} cannot both be enabled at the same time`;
        },
      },
    });
  };
}
